var map = {
	"./ExampleComponent": 9899,
	"./ExampleComponent.vue": 9899,
	"./_account": 6657,
	"./_account.vue": 6657,
	"./course": 1640,
	"./course.vue": 1640,
	"./declar": 4335,
	"./declar.vue": 4335,
	"./doSurvey": 2151,
	"./doSurvey.bak": 7277,
	"./doSurvey.bak.vue": 7277,
	"./doSurvey.vue": 2151,
	"./dpt-account": 6154,
	"./dpt-account.vue": 6154,
	"./group": 1375,
	"./group.vue": 1375,
	"./guide": 8744,
	"./guide.vue": 8744,
	"./header": 1658,
	"./header.vue": 1658,
	"./home": 361,
	"./home.vue": 361,
	"./login": 7478,
	"./login.vue": 7478,
	"./mcu2020": 5343,
	"./mcu2020.vue": 5343,
	"./purchase": 1163,
	"./purchase.vue": 1163,
	"./register": 6006,
	"./register.vue": 6006
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2053;